var bighouse = bighouse || {};

bighouse.mobileNav = (function () {

    var lastFocus;
    var menuOpen = false;

    function init() {
        bindEvents();
        generateMarkup();
    }

    function generateMarkup(){
        var navMarkup = "<div><a href='/'>Home</a></div>" + $('.Nav').html();
        $('.MobileMenu-links').html( navMarkup );

        $('.MobileMenu-links .js-navHasMegaMenu').each(function(){
            var id = $(this).attr('data-menuid');

            var linkMarkup = '<div class="Nav-dropdownLinks js-navDropdownLinks">';
            var svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 5 9" width="5" height="9" style="enable-background:new 0 0 5 9;" xml:space="preserve"><polygon points="0,1 1.2,0 4.6,4 5,4.5 4.6,5 1.2,9 0,8 3,4.5 "/></svg>';
            var svgChildLinks = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 9 5" width="9" height="5" style="enable-background:new 0 0 9 5;" xml:space="preserve"><polygon points="8,0 4.5,3 1,0 0,1.2 4,4.6 4.5,5 5,4.6 9,1.2 "></polygon></svg>';


            document.querySelectorAll('.' + id + ' .js-nav-mobileLinks a').forEach((mobileLink, index) => {
                if(mobileLink.hasAttribute('data-haschildren') && mobileLink.getAttribute('data-haschildren').toLowerCase() == 'true'){
                    
                    let tertiaryItems = JSON.parse(mobileLink.parentNode.querySelector('.js-nav-tertiary-items').textContent);

                    linkMarkup += '<div class="Nav-dropdownAccordion js-dropdown-accordion">';
                        linkMarkup += '<button id="ddacc_btn_'+index+'" aria-controls="ddacc_panel_'+index+'" type="button" class="Nav-dropdownAccordion-label js-dropdown-accordion-button" data-active="false"><span>' + mobileLink.textContent + '</span> ' + svgChildLinks + '</button>';    
                        linkMarkup += '<div id="ddacc_panel_'+index+'" aria-hidden="true" aria-labelledby="ddacc_btn_'+index+'" class="Nav-dropdownAccordion-panel js-dropdown-accordion-panel">';

                            tertiaryItems.forEach(tertiaryItem => {
                                linkMarkup += '<a  class="Nav-dropdownLink" href="' + tertiaryItem.url + '" >' + tertiaryItem.name + '</a>';
                            });

                            linkMarkup += '<span class="Nav-dropdownLink"><a href="' + mobileLink.getAttribute('href') + '" >View all</a> <span> ' + mobileLink.textContent + '</span></span>';    


                        linkMarkup += '</div>';

                    linkMarkup += '</div>';
                } else {
                    linkMarkup += '<a href="' + mobileLink.getAttribute('href') + '" class="Nav-dropdownLink">' + mobileLink.textContent + '</a>';    
                }
            });

            linkMarkup += '</div>';


            $('.MobileMenu-links').find('.js-navHasMegaMenu[data-menuid="' + id + '"]').after( linkMarkup );
       
        });

        setTimeout(bindMobileAccordion, 200);
    }

    function bindEvents() {

        $('.js-toggleMenu').on('click', function (e) {

            if(  $('#mobileMenu').attr('aria-hidden') === 'true' ){
                open();
            } else {
                close(e);
            }

            e.preventDefault();
        });

        $('.js-closeMenu').on('click', function (e) {
            close(e);
            e.preventDefault();
        });

        $(document).on('keydown', function (e) {
            close(e);
        });
    }

    function bindMobileAccordion(){
        //js-dropdown-accordion
        //js-dropdown-accordion-panel
        //js-dropdown-accordion-button
        document.querySelectorAll('.js-dropdown-accordion').forEach((accordion) => {
            let panel = accordion.querySelector('.js-dropdown-accordion-panel');
            let button = accordion.querySelector('.js-dropdown-accordion-button');
        
        
            button.addEventListener('click', function(e){
                if(this.getAttribute('data-active') == 'true'){
                    //close accordion
                    panel.setAttribute("aria-hidden", "true");
                    button.setAttribute("data-active", "false");
                } else {
                    //open accordion
                    panel.setAttribute("aria-hidden", "false");
                    button.setAttribute("data-active", "true");
                }
                e.stopPropagation();
                e.preventDefault();
            });
        });
    }

    function open() {
        // store the last place the user opened the lightbox from
        lastFocus = document.activeElement;
        $('body, html').addClass('noscroll-tablet u-menuOpen');
        var mobileMenu = $('#mobileMenu');
        mobileMenu.attr('aria-hidden', 'false');
        menuOpen = true;
        mobileMenu.find('.MobileMenu-content').attr('tabindex', '0').focus();

        $(mobileMenu).scrollTop(0);

    }

    function close(e) {

        if (menuOpen && (!e.keyCode || e.keyCode === 27)) {
            $('.MobileMenu').attr('aria-hidden', 'true');
            $('.MobileMenu-content').attr('tabindex', '-1');
            menuOpen = false;
            $('body, html').removeClass('noscroll-tablet u-menuOpen');
            lastFocus.focus();
        }
    }


    return {
        init: init
    };
})();